<template>
  <CollapseSection
    :title="`Documentos <i class='fa fa-angle-right mx-2'></i> <span class='text-dark' style='box-shadow:none !important;'>Demonstrativos financeiros</span>`"
    :expanded="expanded"
    :disabled="disabled"
    :loading="loading"
    section-id="documentos"
    @toggleSection="$emit('toggleSection')"
  >
    <!-- <i class='fa fa-asterisk text-warning ml-1'></i> -->
    <div class="pb-5">

        <div v-if="alertMessage">
            <b-alert show :variant="alertVariant">{{ alertMessage }}</b-alert>
        </div>
        
        <b-tabs v-if="editable">
            <b-tab v-for="balanceType in balanceTypes" :key="balanceType"
                :title="getTabTitle(balanceType)"
                :value="balanceType" class="nav-item">
                <b-card-text>
                    <div class="border-left border-bottom border-right p-3 tab-content">
                        <upload-data :files="getFilesByType(
															isAcceptedDocumentType(balanceType)
																? balanceType
																: balanceType.substring(8)
														)"
                            :url="urlUpload" :forceRedirect="true" @deleteFile="deleteFile"
                            @uploadFinished="saveFiles" @showEconomicGroupFiles="showEconomicGroupFiles"
                            :title="'Preencha os campos de Dados do Tomador'" :autoProcessQueue="true"
                            :balanceType="balanceType" :alertRemove="'Deseja remover o arquivo?'" ref="upload" />
                    </div>
                </b-card-text>
                <p class="mt-3"><i class="fa fa-asterisk text-warning ml-1"></i> Todos os Balanços e Balancetes devem estar com DRE.</p>
            </b-tab>
        </b-tabs>

        <div class="d-block" v-if="!editable && filesFlat.length">
            <div class="scrollable-table mb-3" style="max-height: 450px">
              <b-table class="pretty font-14 sticky-header" :items="filesFlat"
                :fields="fieldsFiles">
                <template #cell(balance_type)="data">
                  {{ getEnumKeyByEnumValue(balanceTypesTranslate, data.value) }}
                </template>
                <template #cell(id)="data">
                  <a @click="downloadEconomicGroupFile(data.item)" class="text-secondary ml-2"
                    data-toggle="tooltip" title="Download" data-original-title="down">
                    <i class="fa fa-cloud-download-alt"></i>
                  </a>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col-12">
                <button @click="downloadEconomicGroupFiles()" class="button btn btn-outline-secondary float-right">
                  <i class="fa fa-file-archive mr-1"></i>
                  Fazer download de todos os documentos
                </button>
              </div>
            </div>
        </div>

        <p v-if="!editable && !filesFlat.length">Sem documentos.</p>
                
    </div>

  </CollapseSection>
</template>

<script>
import { CollapseSection } from '@/components';
import { UploadData } from "@/components/Client";
import commomsHelperMixin from "@/mixins/commomsHelper";
import balanceTypes from "@/enums/balanceTypes";
import balanceTypesTranslate from "@/enums/translate/balanceTypes";
import companyService from "@/services/company";
import fileDownload from "js-file-download";

export default {
  components: { 
    CollapseSection,
    UploadData,
  },
  props: {
    expanded: Boolean,
    disabled: Boolean,
    economicGroupID: String,
    editable: { type: Boolean, default: false }
  },
  mixins: [commomsHelperMixin],
  data: () => ({
    loading: false,
    urlUpload: "/api/v1/economic-group-file/UUID/files/BALANCE_TYPE",
    balanceTypes: balanceTypes,
    balanceTypesTranslate: balanceTypesTranslate,
    filesGrouped: [],
		fileSelected: null,
  }),
	created() {
		this.resetAlert();
		if (this.expanded && this.economicGroupID) {
				this.findData();
		}
	},
  methods: {
    findData() {
        this.showEconomicGroupFiles();
    },
    showEconomicGroupFiles() {
        this.loading = true;
        companyService
            .showEconomicGroupFiles(this.economicGroupID)
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.filesGrouped = response.data;
                this.clearUploadState();
            })
            .catch(() => {
                this.showError("Não foi possível visualizar os arquivos dos grupos econômicos.");
            })
            .finally(() => {
                this.loading = false;
            });
    },
    clearUploadState() {
      if (this.$refs.upload) {
          const keys = Object.keys(balanceTypes);
          for (let i = 0; i < keys.length; i++) {
              this.$refs.upload[i].clearUploadState();
          }
        }
    },
    getTabTitle(balanceType) {
      if (this.isAcceptedDocumentType(balanceType)) {
        return this.getEnumKeyByEnumValue(
          this.balanceTypesTranslate,
          balanceType
        );
      }
      return "Balanço " + balanceType.substring(8);
    },
    isAcceptedDocumentType(balanceType) {
      return (
        balanceType == "CORPORATE-DOCUMENTATION" ||
        balanceType == "APPOINTMENT" ||
        balanceType == "OTHERS"
      );
    },
		getFilesByType(type) {
			if (!this.filesGrouped) return [];

			return this.filesGrouped[type] || [];
		},
    deleteFile(fileId) {
			this.loading = true;
        companyService
          .deleteEconomicGroupFile(fileId)
          .then((response) => {
            if (response.data.error) {
              this.showError(response.data.message);
              return;
            }
          })
          .catch(() => {
            this.showError("Erro ao apagar o arquivo do grupos economico.");
          })
          .finally(() => {
            this.loading = false;
						this.showEconomicGroupFiles();
          });
    },
    saveFiles(balance_type) {
      this.urlUpload = `/api/v1/economic-group-file/${this.economicGroupID}/files/${balance_type}`;
      this.$nextTick(() => {
        this.$refs.upload.forEach((element) => {
					if (
						balance_type == element.balanceType &&
						element.$refs.dropzone.getAcceptedFiles().length > 0
					) {
            element.$refs.dropzone.processQueue();
            return;
					}
        });
      });
    },
    downloadEconomicGroupFile(data) {
      this.loading = true;
      companyService
        .downloadEconomicGroupFile(data.id)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.openLinkTargetBlank(response.data.url);
        })
        .catch(() => {
          this.showError("Não foi possível apagar os grupos economicos.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadEconomicGroupFiles() {
      this.loading = true;
      companyService
        .downloadEconomicGroupZipFile(this.economicGroupID)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          const groupName = this.company.group_name.split(" ")[0];
          const currentDate = new Date().toISOString().slice(0, 10);
          fileDownload(response.data, `${groupName}_${currentDate}.zip`);
        })
        .catch(() => {
          this.showError("Não foi possível baixar o arquivo ZIP.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    fieldsFiles() {
      var columns = [
        {
          key: "balance_type",
          label: "Categoria",
          tdClass: "font-6",
          thClass: "table-pretty dbo-ui rounded-top",
        },
        {
          key: "name",
          label: "NOME DO DOCUMENTO	",
          tdClass: "font-6",
          thClass: "table-pretty dbo-ui w-75",
        },
        {
          key: "id",
          label: "",
          tdClass: "font-6",
          thClass: "table-pretty dbo-ui rounded-top",
        },
      ];
      return columns;
    },
    filesFlat() {
      if (!this.filesGrouped) return []

      return Object.entries(this.filesGrouped).flatMap(([key, items]) =>
        items.map(item => ({
          ...item,
          group: key
        }))
      )
    }
  },
  watch: {
    expanded: function (value) {
      if (value) {
        this.resetAlert();
        this.findData();
      }
    },
  }
}
</script>